<template>
  <div class="sky-page-terminal-view">
    <div class="page-from-item wsp-display-flex wsp-padding-tb-12">
      <div class="page-from-value from-value">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
    <div class="page-from-item">
      <div>
        <span>操作系统选择:</span>
        <div class="page-function-toolbar">
          <el-button icon="el-icon-refresh" class="toolbar-left" @click="refreshTable"></el-button>
          <el-input
            placeholder="请输入操作系统查询"
            class="toolbar-input"
            size="medium"
            v-model="searchKeyword"
            @blur="searchReq"
            @change="searchReq"
          >
            <span slot="suffix" class="el-input__suffix"
              ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
            </span>
          </el-input>
          <div class="el-icon-warning wsp-padding-lr-6 wsp-line-height-24 bg-red">
            当前筛选对大小写敏感
          </div>
          <el-pagination
            class="toolbar-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
      </div>
      <div class="page-from-value">
        <el-table
          ref="table"
          :border="true"
          :max-height="700"
          :data="listData"
          :show-header="true"
          :column-drag-sortable="false"
          class="sky-host-dist"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" :selectable="selectable" width="55"></el-table-column>
          <el-table-column
            label="操作系统"
            :filter-method="filterOsType"
            :filters="osTypeList"
            prop="osType"
            show-overflow-tooltip
            width="240"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="!checkSupport(scope.row)"
                class="item"
                effect="dark"
                content="操作系统类型不支持当前测试方案"
                placement="bottom"
              >
                <div class="el-icon-warning bg-red wsp-padding-left-5 wsp-line-height-24"></div>
              </el-tooltip>
              <span>{{ scope.row.osType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支持的类型" prop="useRange" show-overflow-tooltip width="230">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.useRange === 'DESKTOP'" type="success">云桌面操作系统</el-tag>
              <el-tag v-else-if="scope.row.useRange === 'APP'" type="primary">云应用主机操作系统</el-tag>
              <el-tag v-else-if="scope.row.useRange === 'HOST'" type="warning">云桌面/云应用宿主机操作系统</el-tag>
              <el-tag v-else type="info">不限制</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支持的应用场景" prop="useScene" show-overflow-tooltip width="130px">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.useScene === 'VDI'" type="success">VDI</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'IDV'" type="primary">IDV</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'TCI'" type="warning">TCI</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'CLOUD_DOCK'" type="success">云坞</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'SINGLE_SESSION'" type="primary">单会话</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'MULTIPLE_SESSIONS'" type="warning">多会话</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'CLOUD_DOCK_HOST'" type="warning">云坞</el-tag>
              <el-tag v-else-if="scope.row.useScene === 'OC'" type="success">锐捷工作空间</el-tag>
              <el-tag v-else type="info">不限制</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支持的产品版本" prop="productVersion" show-overflow-tooltip width="160px" />
          <el-table-column label="限制说明" prop="remarks" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, Tag, RadioGroup, RadioButton, Input } from 'element-ui'

import { getOsTypeConfig, getAllOsType } from '@/api/osType'

// import lang from '@/lang'
export default {
  name: 'SkyOsTypeConfigTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    subType: {
      type: String,
      default: function() {
        return null
      }
    },
    productIds: {
      type: String,
      default: function() {
        return null
      }
    }
  },
  data: function() {
    return {
      osTypeList: [],
      selectItem: null,
      dialogVisible: false,
      listData: [],
      pageTotal: 0,
      pageSize: 20,
      searchKeyword: '',
      reqParams: {
        exactMatchArr: [],
        matchArr: [],
        page: this.page - 1,
        limit: 20,
        sortArr: [{ fieldName: 'osType', direction: 'DESC' }]
      },
      page: 1
    }
  },
  mounted() {
    this.getData()
  },
  created() {},
  methods: {
    refreshTable() {
      this.getData()
    },
    getData() {
      this.reqParams.page = this.page - 1
      this.reqParams.limit = this.pageSize
      const exists = this.reqParams.matchArr.some(obj => obj.fieldName === 'useRange')
      if (!exists) {
        this.reqParams.matchArr.push({
          type: 'EXACT',
          fieldName: 'useRange',
          valueArr: [this.subType],
          matchRule: 'EQ'
        })
      }
      this.reqParams.matchArr.push({
        type: 'EXACT',
        fieldName: 'productId',
        valueArr: this.productIds.split(','),
        matchRule: 'EQ'
      })
      getOsTypeConfig(this.reqParams).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
      getAllOsType({}).then(res => {
        this.osTypeList = []
        for (const iterator of res.data.content?.itemArr) {
          this.osTypeList.push({ text: iterator.osType, value: iterator.osType })
        }
      })
    },
    searchReq() {
      if (this.searchKeyword !== '') {
        const exists = this.reqParams.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParams.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParams.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['osType'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParams.matchArr.length; index++) {
          const element = this.reqParams.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParams.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    handleSelectionChange(val) {
      this.selectItem = val
    },
    handleCloseDrawer() {
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    onSubmit() {
      if (this.selectItem.length > 0) {
        this.$emit('addSelect', { select: this.selectItem, type: 'OsTypeConfig', subType: this.subType })
      } else {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一个操作系统', type: 'error' })
      }
    },
    cancel() {
      this.$parent.$parent.closerDrawer()
    },
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    },
    checkSupport(row) {
      return this.productIds ? this.productIds.indexOf(row.productId) >= 0 : true
    },
    selectable(row, index) {
      return this.checkSupport(row)
    },
    filterOsType(value, row) {
      if (!row.osType) {
        return false
      }
      return row.osType === value
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-terminal-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .page-from-label {
      width: 8%;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
